import React from "react";
import {
  UniPageBookingForm,
  UniPageBookingHero,
} from "@modules/study/unipages/booking";
import { LayoutMain } from "@unisearch/theme/layout";

const Booking = () => {
  return (
    <LayoutMain
      fixedPopup={false}
      title="International Student Recruitment Strategy | UniSearch for University Booking"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/university/booking`}
    >
      <UniPageBookingHero />
      <UniPageBookingForm />
    </LayoutMain>
  );
};

export default Booking;
